module.exports = __webpack_public_path__ + "img/cxample_14.739dbf82.png";